import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login/Login";
import Signup from "./components/SignUp/SignUp";

import ProtectedRoute from "./components/ProtectedRout/ProtectedRout";
import Welcome from "./components/Welcome/Welcome";

import DashboardDefault from "./components/Defaultcontent/DashboardDefault";
import Assessment from "./components/Assessments/Assessment";
import Certificate from "./components/Certificate/Certificate";
import UserGuide from "./components/UserGuide/UserGuide";
import FeedBackForm from "./components/Feedback/FeedBackForm";
import MyProfile from "./components/MyProfile/MyProfile";

import AssessmentPage from "./components/AssessmentPage/AssessmentPage";
import SubmitPage from "./components/SubmitPage/SubmitPage";
import Instruction from "./components/Instruction/Instruction";

function App() {
  return (
    <Routes>

      {/* ================= AUTH ================= */}
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* ================= EXAM FULLSCREEN ROUTES ================= */}
      <Route
        path="/instruction/:id"
        element={
          <ProtectedRoute>
            <Instruction />
          </ProtectedRoute>
        }
      />

      <Route
        path="/assessment/:id"
        element={
          <ProtectedRoute>
            <AssessmentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/submit/:attemptId"
        element={<SubmitPage />}
      />

      {/* ================= MAIN APP (WITH SIDEBAR) ================= */}
      <Route
        element={
          <ProtectedRoute>
            <Welcome />
          </ProtectedRoute>
        }
      >

        <Route path="/home" element={<Navigate to="/dashboard" replace />} />

        <Route path="/dashboard" element={<DashboardDefault />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/certificate" element={<Certificate />} />
        <Route path="/learning-hub" element={<UserGuide />} />
        <Route path="/feedback" element={<FeedBackForm />} />
        <Route path="/my-profile" element={<MyProfile />} />

      </Route>

    </Routes>
  );
}

export default App;